import type React from "react";

export function Link04({ className, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={className}
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.24996 5.8335H5.83329C3.53211 5.8335 1.66663 7.69898 1.66663 10.0002C1.66663 12.3013 3.53211 14.1668 5.83329 14.1668H7.49996C9.80115 14.1668 11.6666 12.3013 11.6666 10.0002M13.75 14.1668H14.1666C16.4678 14.1668 18.3333 12.3014 18.3333 10.0002C18.3333 7.69898 16.4678 5.8335 14.1666 5.8335H12.5C10.1988 5.8335 8.33329 7.69898 8.33329 10.0002"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.66667"
      />
    </svg>
  );
}
